module.exports = __webpack_public_path__ + "img/man-body-front.efd53db9.png";